import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
    },
    carousel: {
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    track: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      height: '435px',
      padding: '0 143px',
    },
    lastItem: {},
    iframe: {
      borderRadius: theme.shape.borderRadius,
      border: 0,
    },
    child: {
      flex: 'none',
      display: 'flex',
      transition: 'all 0.4s ease',
      '&$unselected': {
        transform: 'scale(0.73)',
        margin: '0 -74px',
        cursor: 'pointer',
        '& iframe': {
          pointerEvents: 'none',
        },
      },
    },
    unselected: {},
  }),
  { name: 'VideoCarousel' }
);
